module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "glossary"
    }
  }, [_c('h1', [_vm._v("リファレンスサイト")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("DanceMinder")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "https://danceminder.com/",
      "target": "_blank"
    }
  }, [_vm._v("https://danceminder.com/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      Set DanceだけでなくSiege of Ennisなどの様々なダンスが掲載されている。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("DanceMinder Blog")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "https://danceminder.com/blog/",
      "target": "_blank"
    }
  }, [_vm._v("https://danceminder.com/blog/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      上記サイトのブログ。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Irish Set Dancing")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "http://setdanceteacher.ie/",
      "target": "_blank"
    }
  }, [_vm._v("http://setdanceteacher.ie/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      DanceMinderで目当てのセットが見つからないときはこちら。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Set Dancing News")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "http://sets.ie/",
      "target": "_blank"
    }
  }, [_vm._v("http://sets.ie/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      Bill Lynch氏が運営しているおそらくSet Dance界で一番のウェブサイト。ヨーロッパ各地のセットダンスクラスやケーリーの情報が掲載されている。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Irish Bliss")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "http://irishbliss.org/",
      "target": "_blank"
    }
  }, [_vm._v("http://irishbliss.org/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      EASY IRISH DANCEというウェブサイトを運営しているNoraさんのブログ。アイルランドのSummer Schoolの情報やセットの人気投票などが掲載されている。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Irish Set Dance Music Database")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "http://mabula.net:8000/setmusic/",
      "target": "_blank"
    }
  }, [_vm._v("http://mabula.net:8000/setmusic/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      バーズ(Bars)やリズムで曲を探せるサイト。「踊りたいけれど曲がない…」という時に便利。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("SessionGO")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "https://sessiongo.com/",
      "target": "_blank"
    }
  }, [_vm._v("https://sessiongo.com/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      \"SessionGOでは全国の音楽セッションの情報を検索・投稿することができます。"), _c('br'), _vm._v("\n      また、チャットで気軽にコミュニケーションすることもできます！"), _c('br'), _vm._v("\n      演奏する人はもちろん、お酒や美味しいパブ料理などを楽しみながら聴きたい人にも役立つでしょう！\""), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      ウェブサイトの構成が SetDancePal の構成と同じ vue.js + firebase です。とても良いサイトなのでセッション好きの方は覗いてみてください。\n    ")])], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Scottish Country Dancing Dictionary")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("URL："), _c('a', {
    attrs: {
      "href": "https://www.scottish-country-dancing-dictionary.com/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.scottish-country-dancing-dictionary.com/")])])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      スコットランドのダンスを網羅しているサイト。\n    ")])], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("copyright © 2017-" + _vm._s(new Date().getFullYear()) + " Hiroshi Jo")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e595bb60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reference.vue
// module id = 345
// module chunks = 1